<template>
  <div class="ucar-upload-block" :class="{ 'disabled': disabled }" @click="handleClick">
    <div class="ucar-upload-img-wrapper">
      <img :src="value || defaultImg">
      <div class="ucar-upload-img-tips">{{value ? '点击修改' : '点击上传'}}</div>
      <div v-if="value && deletable" class="ucar-upload-delete" @click.stop="remove"></div>
    </div>
    <div
      class="ucar-upload-block-title"
      v-if="title && showTitle"
      :class="{ 'required': required }"
    >{{title}}</div>
    <div v-if="error" class="ucar-upload-error">{{error}}</div>
  </div>
</template>

<style lang="stylus" scoped>
@import "../styles/variable.styl";

.ucar-upload-block {
  margin-top: 30px;
  width: 330px;
  float: left;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  font-size: $ucar_font_h4;
  color: $ucar_font_color;

  &.disabled {
    pointer-events: none;
    .ucar-upload-img-wrapper, .ucar-upload-block-title {
      opacity: .5;
    }
  }

  &:nth-of-type(2n + 1) {
    margin-right: 30px;
  }

  .ucar-upload-img-wrapper {
    position: relative;
    width: 100%;
    height: 210px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    overflow: hidden;

    img {
      max-width: 100%;
      max-height: 100%;
    }

    .ucar-upload-img-tips {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 40px;
      background-color: rgba(0, 0, 0, 0.5);
      text-align: center;
      font-size: $ucar_font_h6;
      color: #fff;
    }

    .ucar-upload-delete {
      position: absolute;
      right: 10px;
      top: 14px;
      width: 40px;
      height: 40px;
      overflow: hidden;
      background-color: rgba(0, 0, 0, .6);
      border-radius: 20px;

      &::before, &::after {
        content: "";
        position: absolute;
        background: #fff;
        width: 2px;
        height: 70%;
        top: 50%;
        left: 50%;
      }

      &::before {
        transform: translate3d(-50%, -50%, 0) rotate(45deg);
      }

      &::after {
        transform: translate3d(-50%, -50%, 0) rotate(-45deg);
      }
    }
  }

  .ucar-upload-block-title {
    margin-top: 30px;
    font-size: $ucar_font_h5;
    line-height: 1;
    text-align: center;

    &.required {
      padding-left: 0;
    }
  }

  .ucar-upload-error {
    margin-top: 30px;
    line-height: 1.5;
    font-size: $ucar_font_h6;
    color: $ucar_label_color;
  }
}
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    type: {
      type: Number,
      default: 0
    },
    dsc: {
      type: String,
      default: ''
    },
    value: {
      default: ''
    },
    error: {
      default: ''
    },
    defaultImg: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    demoImg: {
      type: String,
      default: ''
    },
    dialogImg: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'normal'
    },
    needModify: {
      type: Boolean,
      default: false
    },
    supportOcr: {
      type: Boolean,
      default: false
    },
    deletable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      modified: 0
    }
  },
  watch: {
    value () {
      this.modified += 1
    }
  },
  computed: {
    disabled () {
      return this.mode === 'modify' && !this.needModify
    }
  },
  methods: {
    remove () {
      this.$emit('input', '')
    },
    handleClick () {
      this.$alert({
        type: 'upload',
        imgType: 48, // 由于某些特殊的原因，需要对type统一处理为一个常量，所以type暂时写死为
        content: this.title,
        supportOcr: this.supportOcr,
        dsc: this.dsc,
        currentSrc: this.dialogImg || this.defaultImg,
        init: !this.value,
        callback: val => {
          this.$emit('input', val)
          // 由于ocr暂时不支持https的图片链接地址，所以需要手动转换为http
          if (this.mode !== 'modify') this.$emit('uploadFinish', val.replace(/https:\/\//, 'http://'))
        }
      })
    }
  }
}
</script>
